import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const ProgressBarElement = ({ element }) => {
  const { 
    data, 
    currentGroupIndex, 
    currentScreenIndex
  } = useOnboarding();

  if (!data || !data.groups || data.groups.length === 0) return null;

  const style = applyStyles(element);

  const groupsCount = data.groups.length;
  const currentGroup = data.groups[currentGroupIndex];
  const screensInGroup = currentGroup?.screens?.length || 1;

  const completedSegments = currentGroupIndex;
  const segmentWidth = 100 / Math.max(groupsCount, 1);
  const inGroupProgress = (currentScreenIndex + 1) / screensInGroup;

  const progressPercentage = Math.min(
    (completedSegments * segmentWidth) + (inGroupProgress * segmentWidth),
    100
  );

  const dotsCount = groupsCount + 1;

  return (
    <div className="progress-wrapper" style={style}>
      <div className="progress-container">
        <div 
          className="progress-bar" 
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <div className="progress-dots">
        {Array.from({ length: dotsCount }).map((_, i) => {
          let className = 'progress-dot';
          if (i <= completedSegments || (i - 1 <= completedSegments && inGroupProgress === 1.0)) {
            className += ' completed';
          } else if (i === completedSegments) {
            className += ' current';
          }
          return <div key={i} className={className} />;
        })}
      </div>
    </div>
  );
};

export default ProgressBarElement;
